(() => {
  if (window.fabricModelInstalled) return;
  window.fabricModelInstalled = true;

  const states = new WeakMap();

  function getFabric(product) {
    const picker = product.querySelector('variant-selects');
    const mapping = picker?.querySelector('[data-fabric-textures]');
    if (!mapping) return null;

    const textures = JSON.parse(mapping.textContent);

    // Fabric swatches and text buttons.
    for (const fieldset of picker.querySelectorAll('fieldset')) {
      const legend = fieldset.querySelector('legend');
      if (!legend?.textContent.trim().startsWith('Fabric:')) continue;

      const input = fieldset.querySelector('input:checked');
      if (input && textures[input.value]) {
        return textures[input.value];
      }
    }

    // Fabric dropdown, if used later.
    const select = picker.querySelector('select[name="options[Fabric]"]');
    return select ? textures[select.value] : null;
  }

  async function updateModel(product) {
    const viewer = product.querySelector('model-viewer');
    const url = getFabric(product);

    if (!viewer?.model || !url) return;

    let state = states.get(viewer);
    if (!state) {
      state = { request: 0, applied: null, textures: new Map() };
      states.set(viewer, state);
    }

    const request = ++state.request;
    if (state.applied === url) return;

    try {
      const material = viewer.model.materials.find(
        item => item.name === 'Material'
      );

      if (!material) {
        console.warn('Fabric material was not found in the model.');
        return;
      }

      if (!state.textures.has(url)) {
        state.textures.set(url, viewer.createTexture(url));
      }

      const texture = await state.textures.get(url);

      // Prevent an earlier selection from overriding a newer one.
      if (request !== state.request || getFabric(product) !== url) return;

      const textureInfo = material.pbrMetallicRoughness.baseColorTexture;
      textureInfo.setTexture(texture);
      material.pbrMetallicRoughness.setRoughnessFactor(1);
      material.pbrMetallicRoughness.setMetallicFactor(0);

      // Preserve the repetition used by your uploaded GLB.
      //textureInfo.setScale({ u: 30, v: 30 });
      //textureInfo.setOffset({ u: 0, v: -29 });

      state.applied = url;
    } catch (error) {
      state.textures.delete(url);
      console.error('Could not update the fabric texture:', error);
    }
  }

  function updateAll() {
    document.querySelectorAll('product-info').forEach(updateModel);
  }

  // Works when the viewer loads after clicking its 3D preview.
  document.addEventListener('load', event => {
    if (event.target.tagName !== 'MODEL-VIEWER') return;
    const product = event.target.closest('product-info');
    if (product) updateModel(product);
  }, true);

  document.addEventListener('change', event => {
    const picker = event.target.closest('variant-selects');
    const product = picker?.closest('product-info');
    if (product) updateModel(product);
  });

  // Craft replaces parts of the product HTML after variant changes.
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      updateAll();
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
  updateAll();
})();